import { useEffect, useRef, useState } from "react";
import { useOpenLobbyStore } from "./games/openlobby/store";
import i18n from "./i18n/config";

export function useOpenLobbySSE(language: string, enabled = true) {
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const esRef = useRef<EventSource | null>(null);

  useEffect(() => {
    useOpenLobbyStore.getState().clear();
    if (!enabled) {
      setConnected(false);
      setError(null);
      return;
    }

    const url = `/api/open_lobby/events?language=${encodeURIComponent(language)}`;
    console.log(`[OpenLobbySSE] Connecting to ${url}`);
    const es = new EventSource(url);
    esRef.current = es;

    es.onopen = () => {
      console.log("[OpenLobbySSE] Connected");
      setConnected(true);
      setError(null);
    };

    es.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        useOpenLobbyStore.getState().update_game(data);
      } catch (err) {
        console.error(
          "[OpenLobbySSE] Failed to parse message:",
          err,
          "data was:",
          JSON.stringify(event.data),
        );
      }
    };

    es.onerror = (event) => {
      console.error(
        "[OpenLobbySSE] Error:",
        event,
        "readyState:",
        es.readyState,
      );
      setConnected(false);
      setError(i18n.t("errors.connectionLost"));
    };

    return () => {
      es.close();
      esRef.current = null;
    };
  }, [enabled, language]);

  return { connected, error };
}
